module.exports = __webpack_public_path__ + "img/icon_punched-card1.696965d8.svg";